export function route(path, component, name, options) {
  return {
    path, 
    component,
    name,
    ...options,
  }
}
